import { render, staticRenderFns } from "./CourseraCategories.vue?vue&type=template&id=90c53b02&scoped=true&"
import script from "./CourseraCategories.vue?vue&type=script&lang=ts&"
export * from "./CourseraCategories.vue?vue&type=script&lang=ts&"
import style0 from "./CourseraCategories.vue?vue&type=style&index=0&id=90c53b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c53b02",
  null
  
)

export default component.exports